module.exports = __webpack_public_path__ + "static/img/guangqi.dd742ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/market/guangqi.png
// module id = IbXa
// module chunks = 2